import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';
import { featureFlagCheckKeys } from './checks/keys';

const featureFlagsKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
    id: <U extends QueryKeyParam>(uuid: U) =>
      createQueryKey({
        all: [...keys, uuid] as const,
        detail: [...keys, uuid, 'detail'] as const,
        check: featureFlagCheckKeys([...keys, uuid]),
      }),
  });

export { featureFlagsKeys };
